var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("g", [
    _c("circle", {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.map.highlighted,
          expression: "map.highlighted"
        }
      ],
      attrs: {
        r: _vm.w / 2,
        cx: _vm.pos.x,
        cy: _vm.pos.y,
        fill: "white",
        stroke: "white",
        opacity: "0.7",
        "stroke-width": "1"
      }
    }),
    _c(
      "g",
      {
        attrs: { filter: _vm.filter, opacity: _vm.opacity },
        on: { mouseup: _vm.stop_drag, mousedown: _vm.start_drag }
      },
      [
        _vm.is_locked
          ? _c("circle", {
              attrs: {
                r: 1,
                cx: _vm.pos.x,
                cy: _vm.pos.y,
                fill: "none",
                stroke: _vm.locked_sextant_color,
                opacity: "0.7",
                "stroke-width": "0.1"
              }
            })
          : _vm._e(),
        _c(
          "g",
          {
            on: {
              click: [
                function($event) {
                  if (
                    $event.ctrlKey ||
                    $event.shiftKey ||
                    $event.altKey ||
                    $event.metaKey
                  ) {
                    return null
                  }
                  $event.stopPropagation()
                  _vm.clicked($event)
                },
                function($event) {
                  if (!$event.altKey) {
                    return null
                  }
                  _vm.shape($event)
                },
                function($event) {
                  if (!$event.shiftKey) {
                    return null
                  }
                  _vm.complete($event)
                },
                function($event) {
                  if (!$event.ctrlKey) {
                    return null
                  }
                  _vm.alternate_sextant($event)
                },
                function($event) {
                  if (!$event.metaKey) {
                    return null
                  }
                  _vm.alternate_sextant($event)
                }
              ],
              mouseup: function($event) {
                $event.preventDefault()
              }
            }
          },
          [
            _vm.can_shape
              ? _c("image", {
                  ref: "shaped",
                  staticClass: "svg-pan-zoom-control",
                  attrs: {
                    "xlink:href": _vm.img(_vm.map.shaped_image),
                    x: _vm.iconX,
                    y: _vm.iconY,
                    width: _vm.w,
                    height: _vm.h
                  }
                })
              : _vm._e(),
            _c("image", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.map.shaped,
                  expression: "!map.shaped"
                }
              ],
              ref: "normal",
              staticClass: "svg-pan-zoom-control",
              attrs: {
                "xlink:href": _vm.img(_vm.map.image),
                x: _vm.iconX,
                y: _vm.iconY,
                width: _vm.w,
                height: _vm.h
              }
            })
          ]
        ),
        _c(
          "text",
          {
            attrs: {
              x: _vm.textX,
              y: _vm.textY,
              "text-anchor": "middle",
              "font-size": "0.8",
              "font-weight": "bold",
              fill: "white",
              "stroke-width": "0.02",
              stroke: "black"
            }
          },
          [_vm._v(_vm._s(_vm.map.name))]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-05e9e881", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05e9e881","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AtlasMap.vue
// module id = 36
// module chunks = 0